import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess, loadFieldOptions, fetchUserPersonaRecords, fetchCurrentUserProfileAccessRequests, fetchCurrentUser, loadCompanyCredentialDetails, ensureProfileListingAdminId } from '../../ducks/user.duck';
import { fetchLinkPage } from '../../ducks/linkedContacts.duck';
import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getLocationDetails, updateOtherUsers, updateTransactionMetadata, uploadFileToBlob, uploadResumeToBlob, sendOtp, verifyOtp, getPhoneVerifications, manualFieldOptions, sendConsCurrEmpMail, getListingsByIds, sendConsultantInvite, createNewListing, updateLinkedConsultant, shareProfile, getProfileAccessRequests, approveAccessRequest, rejectAccessRequest, searchUsers, saveConsent, getListingWithPrivateData } from '../../util/api';

import { types as sdkTypes } from '../../util/sdkLoader';
import { userTypeOf } from '../../util/userType';
import { withOwnPrivateData } from '../../util/withOwnPrivateData';
import { agencyProjectOptions } from '../../util/recordedProjects';
const { UUID } = sdkTypes;

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ProfileSettingsPage/CLEAR_UPDATED_FORM';

export const UPLOAD_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/ProfileSettingsPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ProfileSettingsPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ProfileSettingsPage/UPDATE_PROFILE_ERROR';

export const FETCH_ALL_USERS_REQUEST = 'app/ProfileSettingsPage/FETCH_ALL_USERS_REQUEST';
export const FETCH_ALL_USERS_SUCCESS = 'app/ProfileSettingsPage/FETCH_ALL_USERS_SUCCESS';
export const FETCH_ALL_USERS_ERROR = 'app/ProfileSettingsPage/FETCH_ALL_USERS_ERROR';

export const CHECK_FOR_OWN_LISTINGS_REQUEST = 'app/ProfileSettingsPage/CHECK_FOR_OWN_LISTINGS_REQUEST';
export const CHECK_FOR_OWN_LISTINGS_SUCCESS = 'app/ProfileSettingsPage/CHECK_FOR_OWN_LISTINGS_SUCCESS';
export const CHECK_FOR_OWN_LISTINGS_ERROR = 'app/ProfileSettingsPage/CHECK_FOR_OWN_LISTINGS_ERROR';

export const BLOB_FILE_UPLOAD_IMAGE_REQUEST = 'app/ProfileSettingsPage/BLOB_FILE_UPLOAD_IMAGE_REQUEST';
export const BLOB_FILE_UPLOAD_IMAGE_SUCCESS = 'app/ProfileSettingsPage/BLOB_FILE_UPLOAD_IMAGE_SUCCESS';
export const BLOB_FILE_UPLOAD_IMAGE_ERROR = 'app/ProfileSettingsPage/BLOB_FILE_UPLOAD_IMAGE_ERROR';

export const SHOW_PROFILE_LISTING_REQUEST = 'app/ProfileSettingsPage/SHOW_PROFILE_LISTING_REQUEST';
export const SHOW_PROFILE_LISTING_SUCCESS = 'app/ProfileSettingsPage/SHOW_PROFILE_LISTING_SUCCESS';
export const SHOW_PROFILE_LISTING_ERROR = 'app/ProfileSettingsPage/SHOW_PROFILE_LISTING_ERROR';
export const PROFILE_LISTING_AUTHOR_RESOLVED = 'app/ProfileSettingsPage/PROFILE_LISTING_AUTHOR_RESOLVED';

export const SHOW_APPLY_WORK_LISTING_REQUEST = 'app/ProfileSettingsPage/SHOW_APPLY_WORK_LISTING_REQUEST';
export const SHOW_APPLY_WORK_LISTING_SUCCESS = 'app/ProfileSettingsPage/SHOW_APPLY_WORK_LISTING_SUCCESS';
export const SHOW_APPLY_WORK_LISTING_ERROR = 'app/ProfileSettingsPage/SHOW_APPLY_WORK_LISTING_ERROR';

export const INITIATE_AGENCY_LINK_REQUEST = 'app/ProfileSettingsPage/INITIATE_AGENCY_LINK_REQUEST';
export const INITIATE_AGENCY_LINK_SUCCESS = 'app/ProfileSettingsPage/INITIATE_AGENCY_LINK_SUCCESS';
export const INITIATE_AGENCY_LINK_ERROR = 'app/ProfileSettingsPage/INITIATE_AGENCY_LINK_ERROR';

export const UPDATE_OTHER_USER_REQUEST = 'app/ProfileSettingsPage/UPDATE_OTHER_USER_REQUEST';
export const UPDATE_OTHER_USER_SUCCESS = 'app/ProfileSettingsPage/UPDATE_OTHER_USER_SUCCESS';
export const UPDATE_OTHER_USER_ERROR = 'app/ProfileSettingsPage/UPDATE_OTHER_USER_ERROR';

export const UPDATE_TRANSACTION_METADATA_REQUEST = 'app/ProfileSettingsPage/UPDATE_TRANSACTION_METADATA_REQUEST';
export const UPDATE_TRANSACTION_METADATA_SUCCESS = 'app/ProfileSettingsPage/UPDATE_TRANSACTION_METADATA_SUCCESS';
export const UPDATE_TRANSACTION_METADATA_ERROR = 'app/ProfileSettingsPage/UPDATE_TRANSACTION_METADATA_ERROR';

export const GET_USERS_LINKED_PROJECTS_REQUEST = 'app/ProfileSettingsPage/GET_USERS_LINKED_PROJECTS_REQUEST';
export const GET_USERS_LINKED_PROJECTS_SUCCESS = 'app/ProfileSettingsPage/GET_USERS_LINKED_PROJECTS_SUCCESS';
export const GET_USERS_LINKED_PROJECTS_ERROR = 'app/ProfileSettingsPage/GET_USERS_LINKED_PROJECTS_ERROR';

export const SHOW_UPDATED_USER_REQUEST = 'app/ProfileSettingsPage/SHOW_UPDATED_USER_REQUEST';
export const SHOW_UPDATED_USER_SUCCESS = 'app/ProfileSettingsPage/SHOW_UPDATED_USER_SUCCESS';
export const SHOW_UPDATED_USER_ERROR = 'app/ProfileSettingsPage/SHOW_UPDATED_USER_ERROR';

export const FETCH_LOCATION_DETAILS_REQUEST = 'app/ProfileSettingsPage/FETCH_LOCATION_DETAILS_REQUEST';
export const FETCH_LOCATION_DETAILS_SUCCESS = 'app/ProfileSettingsPage/FETCH_LOCATION_DETAILS_SUCCESS';
export const FETCH_LOCATION_DETAILS_ERROR = 'app/ProfileSettingsPage/FETCH_LOCATION_DETAILS_ERROR';

export const SEND_OTP_REQUEST = 'app/ProfileSettingsPage/SEND_OTP_REQUEST';
export const SEND_OTP_SUCCESS = 'app/ProfileSettingsPage/SEND_OTP_SUCCESS';
export const SEND_OTP_ERROR = 'app/ProfileSettingsPage/SEND_OTP_ERROR';

export const VERIFY_OTP_REQUEST = 'app/ProfileSettingsPage/VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'app/ProfileSettingsPage/VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_ERROR = 'app/ProfileSettingsPage/VERIFY_OTP_ERROR';

export const FETCH_PHONE_VERIFICATIONS_REQUEST = 'app/ProfileSettingsPage/FETCH_PHONE_VERIFICATIONS_REQUEST';
export const FETCH_PHONE_VERIFICATIONS_SUCCESS = 'app/ProfileSettingsPage/FETCH_PHONE_VERIFICATIONS_SUCCESS';
export const FETCH_PHONE_VERIFICATIONS_ERROR = 'app/ProfileSettingsPage/FETCH_PHONE_VERIFICATIONS_ERROR';

export const INSERT_FIELD_OPTIONS_REQUEST = 'app/ProfileSettingsPage/INSERT_FIELD_OPTIONS_REQUEST';
export const INSERT_FIELD_OPTIONS_SUCCESS = 'app/ProfileSettingsPage/INSERT_FIELD_OPTIONS_SUCCESS';
export const INSERT_FIELD_OPTIONS_ERROR = 'app/ProfileSettingsPage/INSERT_FIELD_OPTIONS_ERROR';

export const SEND_MAIL_REQUEST = 'app/ProfileSettingsPage/SEND_MAIL_REQUEST';
export const SEND_MAIL_SUCCESS = 'app/ProfileSettingsPage/SEND_MAIL_SUCCESS';
export const SEND_MAIL_ERROR = 'app/ProfileSettingsPage/SEND_MAIL_ERROR';

export const GET_ALL_CANDIDATES_LISTINGS_REQUEST = 'app/ProfileSettingsPage/GET_ALL_CANDIDATES_LISTINGS_REQUEST';
export const GET_ALL_CANDIDATES_LISTINGS_SUCCESS = 'app/ProfileSettingsPage/GET_ALL_CANDIDATES_LISTINGS_SUCCESS';
export const GET_ALL_CANDIDATES_LISTINGS_ERROR = 'app/ProfileSettingsPage/GET_ALL_CANDIDATES_LISTINGS_ERROR';

export const SEND_CONSULTANT_MAIL_REQUEST = 'app/ProfileSettingsPage/SEND_CONSULTANT_MAIL_REQUEST';
export const SEND_CONSULTANT_MAIL_SUCCESS = 'app/ProfileSettingsPage/SEND_CONSULTANT_MAIL_SUCCESS';
export const SEND_CONSULTANT_MAIL_ERROR = 'app/ProfileSettingsPage/SEND_CONSULTANT_MAIL_ERROR';

export const UPDATE_PROFILE_LISTING_REQUEST = 'app/ProfileSettingsPage/UPDATE_PROFILE_LISTING_REQUEST';
export const UPDATE_PROFILE_LISTING_SUCCESS = 'app/ProfileSettingsPage/UPDATE_PROFILE_LISTING_SUCCESS';
export const UPDATE_PROFILE_LISTING_ERROR = 'app/ProfileSettingsPage/UPDATE_PROFILE_LISTING_ERROR';

export const UPDATE_LINKED_CONSULTANT_REQUEST = 'app/ProfileSettingsPage/UPDATE_LINKED_CONSULTANT_REQUEST';
export const UPDATE_LINKED_CONSULTANT_SUCCESS = 'app/ProfileSettingsPage/UPDATE_LINKED_CONSULTANT_SUCCESS';
export const UPDATE_LINKED_CONSULTANT_ERROR = 'app/ProfileSettingsPage/UPDATE_LINKED_CONSULTANT_ERROR';

export const SHARE_PROFILE_REQUEST = 'app/ProfileSettingsPage/SHARE_PROFILE_REQUEST';
export const SHARE_PROFILE_SUCCESS = 'app/ProfileSettingsPage/SHARE_PROFILE_SUCCESS';
export const SHARE_PROFILE_ERROR = 'app/ProfileSettingsPage/SHARE_PROFILE_ERROR';
export const CLEAR_SHARE_PROFILE_LINK = 'app/ProfileSettingsPage/CLEAR_SHARE_PROFILE_LINK';

export const GET_PROFILE_ACCESS_REQUESTS_REQUEST = 'app/ProfileSettingsPage/GET_PROFILE_ACCESS_REQUESTS_REQUEST';
export const GET_PROFILE_ACCESS_REQUESTS_SUCCESS = 'app/ProfileSettingsPage/GET_PROFILE_ACCESS_REQUESTS_SUCCESS';
export const GET_PROFILE_ACCESS_REQUESTS_ERROR = 'app/ProfileSettingsPage/GET_PROFILE_ACCESS_REQUESTS_ERROR';

export const APPROVE_ACCESS_REQUEST_REQUEST = 'app/ProfileSettingsPage/APPROVE_ACCESS_REQUEST_REQUEST';
export const APPROVE_ACCESS_REQUEST_SUCCESS = 'app/ProfileSettingsPage/APPROVE_ACCESS_REQUEST_SUCCESS';
export const APPROVE_ACCESS_REQUEST_ERROR = 'app/ProfileSettingsPage/APPROVE_ACCESS_REQUEST_ERROR';

export const REJECT_ACCESS_REQUEST_REQUEST = 'app/ProfileSettingsPage/REJECT_ACCESS_REQUEST_REQUEST';
export const REJECT_ACCESS_REQUEST_SUCCESS = 'app/ProfileSettingsPage/REJECT_ACCESS_REQUEST_SUCCESS';
export const REJECT_ACCESS_REQUEST_ERROR = 'app/ProfileSettingsPage/REJECT_ACCESS_REQUEST_ERROR';

export const SAVE_DOC_CONSENT_REQUEST = 'app/ProfileSettingsPage/SAVE_DOC_CONSENT_REQUEST';
export const SAVE_DOC_CONSENT_SUCCESS = 'app/ProfileSettingsPage/SAVE_DOC_CONSENT_SUCCESS';
export const SAVE_DOC_CONSENT_ERROR = 'app/ProfileSettingsPage/SAVE_DOC_CONSENT_ERROR';

// ================ Reducer ================ //

// Listings fetched for one page of links are added to those fetched for others, replacing any
// fetched again.
const withListings = (kept = [], fetched = []) => {
  const fetchedIds = new Set((fetched || []).map(l => l.id?.uuid));
  return [...(kept || []).filter(l => !fetchedIds.has(l.id?.uuid)), ...(fetched || [])];
};

const initialState = {
  image: null,
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,
  allUsers: [],
  candidateUsers: [],
  customerUsers: [],
  agencyUsers: [],
  recruiters: [],
  candidateOptions: [],
  customerOptions: [],
  agencyOptions: [],
  isFreshUser: null,
  profileListing: [],
  // Whether profileListing carries the company's own credential details; a profile save sends
  // them only when it does.
  profileListingCredentialsLoaded: false,
  // The user the marketplace names as the profile listing's author - the company's admin. Unknown
  // (null) until the listing loads, and while it is, nobody is offered Share.
  profileListingAuthorId: null,
  projectOptions: [],
  agencyLinkTxnId: null,
  profileLinkedProjects: [],
  currentAgencyLinkTxnId: null,
  sendOtpInProgress: false,
  sendOtpError: null,
  verifyOtpInProgress: false,
  verifyOtpError: null,
  // The phones the server has a verification record for, for the signed-in user. A phone counts as
  // verified only when it is here; nothing written on the profile counts.
  verifiedPhoneNumbers: [],
  fetchPhoneVerificationsInProgress: false,
  fetchPhoneVerificationsError: null,
  otpSent: false,
  otpVerified: false,
  mailSent: false,
  sendMailError: null,
  getAllCandidatesListingsInProgress: false,
  getAllCandidatesListingsError: null,
  candidatesListings: [],
  agencyListings: [],
  profileListingUpdationError: null,
  applyWorkListingId: null,
  applyWorkListing: null,
  applyWorkListingLoading: false,
  applyWorkListingError: null,
  updateLinkedConsultantInProgress: false,
  updateLinkedConsultantError: null,
  shareProfileInProgress: false,
  shareProfileError: null,
  shareProfileLink: null,
  profileAccessRequests: [],
  getProfileAccessRequestsInProgress: false,
  getProfileAccessRequestsError: null,
  approveAccessRequestInProgress: false,
  approveAccessRequestError: null,
  rejectAccessRequestInProgress: false,
  rejectAccessRequestError: null,
  // Save doc upload consent
  saveDocConsentInProgress: false,
  saveDocConsentError: null,
  saveDocConsentSuccess: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_IMAGE_REQUEST:
      // payload.params: { id: 'tempId', file }
      return {
        ...state,
        image: { ...payload.params },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      // payload: { id: 'tempId', uploadedImage }
      const { id, uploadedImage } = payload;
      const { file } = state.image || {};
      const image = { id, imageId: uploadedImage.id, file, uploadedImage };
      return { ...state, image, uploadInProgress: false };
    }
    case UPLOAD_IMAGE_ERROR: {
      // eslint-disable-next-line no-console
      return { ...state, image: null, uploadInProgress: false, uploadImageError: payload.error };
    }

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

    case FETCH_ALL_USERS_REQUEST:
      return {
        ...state,
      };
    case FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        allUsers: payload.allUsers,
        candidateUsers: payload.candidateUsers,
        customerUsers: payload.customerUsers,
        agencyUsers: payload.agencyUsers,
        recruiters: payload.recruiters,
        candidateOptions: payload.candidateOptions,
        customerOptions: payload.customerOptions,
        agencyOptions: payload.agencyOptions,
      };
    case FETCH_ALL_USERS_ERROR:
      return {
        ...state,
      };

    // A refresh keeps the answer already on screen; isFreshUser is null only before the first one,
    // so the page is not blanked while the check runs again in the background.
    case CHECK_FOR_OWN_LISTINGS_REQUEST:
      return {
        ...state,
      };
    case CHECK_FOR_OWN_LISTINGS_SUCCESS:
      return {
        ...state,
        isFreshUser: payload,
      };
    // A failed first check still settles the answer, so the page never stays blank; a failed
    // refresh keeps the answer already on screen.
    case CHECK_FOR_OWN_LISTINGS_ERROR:
      return {
        ...state,
        isFreshUser:
          state.isFreshUser !== null ? state.isFreshUser : action.meta?.isFreshUser ?? false,
      };

    case BLOB_FILE_UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        blobFile: { ...payload.params },
        blobFileUploadInProgress: true,
        blobFileUploadError: null,
      };
    case BLOB_FILE_UPLOAD_IMAGE_SUCCESS: {
      const { id, blobUrl } = payload;
      const { file } = state.blobFile || {};
      const blobFile = { id, blobUrl, file };
      return { ...state, blobFile, blobFileUploadInProgress: false };
    }
    case BLOB_FILE_UPLOAD_IMAGE_ERROR: {
      return { ...state, blobFile: null, blobFileUploadInProgress: false, blobFileUploadError: payload.error };
    }

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    case SHOW_PROFILE_LISTING_REQUEST:
      return {
        ...state,
      };
    case SHOW_PROFILE_LISTING_SUCCESS:
      return {
        ...state,
        profileListing: payload,
        profileListingCredentialsLoaded: action.credentialsLoaded === true,
      };
    case SHOW_PROFILE_LISTING_ERROR:
      return {
        ...state,
      };
    case PROFILE_LISTING_AUTHOR_RESOLVED:
      return { ...state, profileListingAuthorId: payload };

    case SHOW_APPLY_WORK_LISTING_REQUEST:
      return {
        ...state,
        applyWorkListing: null,
        applyWorkListingLoading: true,
        applyWorkListingError: null,
      };
    case SHOW_APPLY_WORK_LISTING_SUCCESS:
      return {
        ...state,
        applyWorkListingId: payload?.listingId || null,
        applyWorkListing: payload?.listing || null,
        applyWorkListingLoading: false,
      };
    case SHOW_APPLY_WORK_LISTING_ERROR:
      return {
        ...state,
        applyWorkListing: null,
        applyWorkListingError: payload,
        applyWorkListingLoading: false,
      };

    case INITIATE_AGENCY_LINK_REQUEST:
      return {
        ...state,
      };
    case INITIATE_AGENCY_LINK_SUCCESS:
      return {
        ...state,
        projectOptions: payload.projectOptions,
        agencyLinkTxnId: payload.agencyLinkTxnId,
      };
    case INITIATE_AGENCY_LINK_ERROR:
      return {
        ...state,
      };

    case UPDATE_OTHER_USER_REQUEST:
      return {
        ...state,
      };
    case UPDATE_OTHER_USER_SUCCESS:
      return {
        ...state,
        updated: true,
      };
    case UPDATE_OTHER_USER_ERROR:
      return {
        ...state,
      };

    case UPDATE_TRANSACTION_METADATA_REQUEST:
      return {
        ...state,
      };
    case UPDATE_TRANSACTION_METADATA_SUCCESS:
      return {
        ...state,
        updated: true,
      };
    case UPDATE_TRANSACTION_METADATA_ERROR:
      return {
        ...state,
      };

    case GET_USERS_LINKED_PROJECTS_REQUEST:
      return {
        ...state,
      };
    case GET_USERS_LINKED_PROJECTS_SUCCESS:
      return {
        ...state,
        profileLinkedProjects: payload.profileLinkedProjects,
        projectOptions: payload.agencyProjectOptions,
      };
    case GET_USERS_LINKED_PROJECTS_ERROR:
      return {
        ...state,
      };

    case SHOW_UPDATED_USER_REQUEST:
      return {
        ...state,
      };
    case SHOW_UPDATED_USER_SUCCESS:
      return {
        ...state,
        updatedUser: payload,
      };
    case SHOW_UPDATED_USER_ERROR:
      return {
        ...state,
      };

    case FETCH_LOCATION_DETAILS_REQUEST:
      return {
        ...state,
      };
    case FETCH_LOCATION_DETAILS_SUCCESS:
      return {
        ...state,
      };
    case FETCH_LOCATION_DETAILS_ERROR:
      return {
        ...state,
      };

    case SEND_OTP_REQUEST:
      return {
        ...state,
        sendOtpInProgress: true,
        sendOtpError: null,
      };
    case SEND_OTP_SUCCESS:
      return {
        ...state,
        sendOtpInProgress: false,
        otpSent: true,
      };
    case SEND_OTP_ERROR:
      return {
        ...state,
        sendOtpInProgress: false,
        sendOtpError: payload,
      };

    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        verifyOtpInProgress: true,
        verifyOtpError: null,
      };
    case VERIFY_OTP_SUCCESS: {
      const phoneNumber = payload?.success ? payload?.phoneNumber : null;
      return {
        ...state,
        verifyOtpInProgress: false,
        otpVerified: true,
        verifiedPhoneNumbers:
          phoneNumber && !state.verifiedPhoneNumbers.includes(phoneNumber)
            ? [...state.verifiedPhoneNumbers, phoneNumber]
            : state.verifiedPhoneNumbers,
      };
    }

    case FETCH_PHONE_VERIFICATIONS_REQUEST:
      return { ...state, fetchPhoneVerificationsInProgress: true, fetchPhoneVerificationsError: null };
    case FETCH_PHONE_VERIFICATIONS_SUCCESS:
      return {
        ...state,
        fetchPhoneVerificationsInProgress: false,
        verifiedPhoneNumbers: Array.from(new Set([...state.verifiedPhoneNumbers, ...payload])),
      };
    case FETCH_PHONE_VERIFICATIONS_ERROR:
      return { ...state, fetchPhoneVerificationsInProgress: false, fetchPhoneVerificationsError: payload };
    case VERIFY_OTP_ERROR:
      return {
        ...state,
        verifyOtpInProgress: false,
        verifyOtpError: payload,
      };

    case INSERT_FIELD_OPTIONS_REQUEST:
      return {
        ...state,
      };
    case INSERT_FIELD_OPTIONS_SUCCESS:
      return {
        ...state,
      };
    case INSERT_FIELD_OPTIONS_ERROR:
      return {
        ...state,
      };

    case SEND_MAIL_REQUEST:
      return {
        ...state,
      };
    case SEND_MAIL_SUCCESS:
      return {
        ...state,
        mailSent: true,
      };
    case SEND_MAIL_ERROR:
      return {
        ...state,
        sendMailError: payload,
      };

    case GET_ALL_CANDIDATES_LISTINGS_REQUEST:
      return {
        ...state,
        getAllCandidatesListingsInProgress: true,
        getAllCandidatesListingsError: null,
      };
    case GET_ALL_CANDIDATES_LISTINGS_SUCCESS:
      return {
        ...state,
        getAllCandidatesListingsInProgress: false,
        candidatesListings: withListings(state.candidatesListings, payload?.candidateListings),
        agencyListings: withListings(state.agencyListings, payload?.agencyListings),
      };
    case GET_ALL_CANDIDATES_LISTINGS_ERROR:
      return {
        ...state,
        getAllCandidatesListingsInProgress: false,
        getAllCandidatesListingsError: payload,
      };

    case SEND_CONSULTANT_MAIL_REQUEST:
      return {
        ...state,
      };
    case SEND_CONSULTANT_MAIL_SUCCESS:
      return {
        ...state,
      };
    case SEND_CONSULTANT_MAIL_ERROR:
      return {
        ...state,
      };

    case UPDATE_PROFILE_LISTING_REQUEST:
      return {
        ...state,
        profileListingUpdationError: null,
      };
    case UPDATE_PROFILE_LISTING_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_PROFILE_LISTING_ERROR:
      return {
        ...state,
        profileListingUpdationError: payload,
      };

    case UPDATE_LINKED_CONSULTANT_REQUEST:
      return {
        ...state,
        updateLinkedConsultantInProgress: true,
        updateLinkedConsultantError: null,
      };
    case UPDATE_LINKED_CONSULTANT_SUCCESS:
      return {
        ...state,
        updateLinkedConsultantInProgress: false,
      };
    case UPDATE_LINKED_CONSULTANT_ERROR:
      return {
        ...state,
        updateLinkedConsultantInProgress: false,
        updateLinkedConsultantError: payload,
      };

    case SHARE_PROFILE_REQUEST:
      return {
        ...state,
        shareProfileInProgress: true,
        shareProfileError: null,
        shareProfileLink: null,
      };
    case SHARE_PROFILE_SUCCESS:
      return {
        ...state,
        shareProfileInProgress: false,
        shareProfileLink: payload.shareLink,
      };
    case SHARE_PROFILE_ERROR:
      return {
        ...state,
        shareProfileInProgress: false,
        shareProfileError: payload,
      };
    case CLEAR_SHARE_PROFILE_LINK:
      return {
        ...state,
        shareProfileLink: null,
        shareProfileError: null,
      };

    case GET_PROFILE_ACCESS_REQUESTS_REQUEST:
      return {
        ...state,
        getProfileAccessRequestsInProgress: true,
        getProfileAccessRequestsError: null,
      };
    case GET_PROFILE_ACCESS_REQUESTS_SUCCESS:
      return {
        ...state,
        getProfileAccessRequestsInProgress: false,
        profileAccessRequests: payload.requests || [],
      };
    case GET_PROFILE_ACCESS_REQUESTS_ERROR:
      return {
        ...state,
        getProfileAccessRequestsInProgress: false,
        getProfileAccessRequestsError: payload,
      };

    case APPROVE_ACCESS_REQUEST_REQUEST:
      return {
        ...state,
        approveAccessRequestInProgress: true,
        approveAccessRequestError: null,
      };
    case APPROVE_ACCESS_REQUEST_SUCCESS:
      return {
        ...state,
        approveAccessRequestInProgress: false,
        // Remove the approved request from the list
        profileAccessRequests: state.profileAccessRequests.filter(
          req => req._id !== payload.requestId
        ),
      };
    case APPROVE_ACCESS_REQUEST_ERROR:
      return {
        ...state,
        approveAccessRequestInProgress: false,
        approveAccessRequestError: payload,
      };

    case REJECT_ACCESS_REQUEST_REQUEST:
      return {
        ...state,
        rejectAccessRequestInProgress: true,
        rejectAccessRequestError: null,
      };
    case REJECT_ACCESS_REQUEST_SUCCESS:
      return {
        ...state,
        rejectAccessRequestInProgress: false,
        // Remove the rejected request from the list
        profileAccessRequests: state.profileAccessRequests.filter(
          req => req._id !== payload.requestId
        ),
      };
    case REJECT_ACCESS_REQUEST_ERROR:
      return {
        ...state,
        rejectAccessRequestInProgress: false,
        rejectAccessRequestError: payload,
      };

    case SAVE_DOC_CONSENT_REQUEST:
      return { ...state, saveDocConsentInProgress: true, saveDocConsentError: null, saveDocConsentSuccess: false };
    case SAVE_DOC_CONSENT_SUCCESS:
      return { ...state, saveDocConsentInProgress: false, saveDocConsentSuccess: true };
    case SAVE_DOC_CONSENT_ERROR:
      return { ...state, saveDocConsentInProgress: false, saveDocConsentError: payload };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

export const clearShareProfileLink = () => ({
  type: CLEAR_SHARE_PROFILE_LINK,
});

// SDK method: images.upload
export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

export const fetchAllUsersRequest = params => ({ type: FETCH_ALL_USERS_REQUEST, payload: { params } });
export const fetchAllUsersSuccess = result => ({ type: FETCH_ALL_USERS_SUCCESS, payload: result });
export const fetchAllUsersError = error => ({
  type: FETCH_ALL_USERS_ERROR,
  payload: error,
  error: true,
});

export const checkForOwnListingsRequest = params => ({ type: CHECK_FOR_OWN_LISTINGS_REQUEST, payload: { params } });
export const checkForOwnListingsSuccess = result => ({ type: CHECK_FOR_OWN_LISTINGS_SUCCESS, payload: result });
export const checkForOwnListingsError = (error, isFreshUser) => ({
  type: CHECK_FOR_OWN_LISTINGS_ERROR,
  payload: error,
  error: true,
  meta: { isFreshUser },
});

// Whether this user still has onboarding ahead of them. It is read from the user's own profile.
const isFreshUserOf = currentUser => {
  const publicData = currentUser?.attributes?.profile?.publicData || {};
  const isOnboardedUser = (publicData?.profileListingId && publicData?.addedUserJoined) || publicData?.firstListingId;
  return !isOnboardedUser;
};

export const uploadBlobFileRequest = params => ({ type: BLOB_FILE_UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadBlobFileSuccess = result => ({ type: BLOB_FILE_UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadBlobFileError = error => ({
  type: BLOB_FILE_UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

export const showProfileListingRequest = params => ({
  type: SHOW_PROFILE_LISTING_REQUEST,
  payload: { params },
});
// A listing shown without `credentialsLoaded` is taken not to carry the company's credential details.
export const showProfileListingSuccess = (result, { credentialsLoaded = false } = {}) => ({
  type: SHOW_PROFILE_LISTING_SUCCESS,
  credentialsLoaded,
  payload: result,
});
export const showProfileListingError = error => ({
  type: SHOW_PROFILE_LISTING_ERROR,
  payload: error,
  error: true,
});
export const profileListingAuthorResolved = authorId => ({
  type: PROFILE_LISTING_AUTHOR_RESOLVED,
  payload: authorId,
});

export const showApplyWorkListingRequest = params => ({
  type: SHOW_APPLY_WORK_LISTING_REQUEST,
  payload: { params },
});
export const showApplyWorkListingSuccess = result => ({
  type: SHOW_APPLY_WORK_LISTING_SUCCESS,
  payload: result,
});
export const showApplyWorkListingError = error => ({
  type: SHOW_APPLY_WORK_LISTING_ERROR,
  payload: error,
  error: true,
});

export const initiateAgencyLinkRequest = params => ({
  type: INITIATE_AGENCY_LINK_REQUEST,
  payload: { params },
});
export const initiateAgencyLinkSuccess = result => ({
  type: INITIATE_AGENCY_LINK_SUCCESS,
  payload: result,
});
export const initiateAgencyLinkError = error => ({
  type: INITIATE_AGENCY_LINK_ERROR,
  payload: error,
  error: true,
});

export const updateOtherUserRequest = params => ({
  type: UPDATE_OTHER_USER_REQUEST,
  payload: { params },
});
export const updateOtherUserSuccess = result => ({
  type: UPDATE_OTHER_USER_SUCCESS,
  payload: result,
});
export const updateOtherUserError = error => ({
  type: UPDATE_OTHER_USER_ERROR,
  payload: error,
  error: true,
});

export const updateTransactionMetadataRequest = params => ({
  type: UPDATE_TRANSACTION_METADATA_REQUEST,
  payload: { params },
});
export const updateTransactionMetadataSuccess = result => ({
  type: UPDATE_TRANSACTION_METADATA_SUCCESS,
  payload: result,
});
export const updateTransactionMetadataError = error => ({
  type: UPDATE_TRANSACTION_METADATA_ERROR,
  payload: error,
  error: true,
});

export const getUsersLinkedProjectsRequest = params => ({
  type: GET_USERS_LINKED_PROJECTS_REQUEST,
  payload: { params },
});
export const getUsersLinkedProjectsSuccess = result => ({
  type: GET_USERS_LINKED_PROJECTS_SUCCESS,
  payload: {
    profileLinkedProjects: result.profileLinkedProjects,
    agencyProjectOptions: result.agencyProjectOptions,
  },
});
export const getUsersLinkedProjectsError = error => ({
  type: GET_USERS_LINKED_PROJECTS_ERROR,
  payload: error,
  error: true,
});

export const showUpdatedUserRequest = params => ({
  type: SHOW_UPDATED_USER_REQUEST,
  payload: { params },
});
export const showUpdatedUserSuccess = result => ({
  type: SHOW_PROFILE_LISTING_REQUEST,
  payload: result,
});
export const showUpdatedUserError = error => ({
  type: SHOW_PROFILE_LISTING_ERROR,
  payload: error,
  error: true,
});

export const fetchLocationDetailsRequest = params => ({
  type: FETCH_LOCATION_DETAILS_REQUEST,
  payload: { params },
});
export const fetchLocationDetailsSuccess = result => ({
  type: FETCH_LOCATION_DETAILS_SUCCESS,
  payload: result,
});
export const fetchLocationDetailsError = error => ({
  type: FETCH_LOCATION_DETAILS_ERROR,
  payload: error,
  error: true,
});

export const sendOtpRequest = params => ({
  type: SEND_OTP_REQUEST,
  payload: { params },
});
export const sendOtpSuccess = result => ({
  type: SEND_OTP_SUCCESS,
  payload: result,
});
export const sendOtpError = error => ({
  type: SEND_OTP_ERROR,
  payload: error,
  error: true,
});

export const verifyOtpRequest = params => ({
  type: VERIFY_OTP_REQUEST,
  payload: { params },
});
export const verifyOtpSuccess = result => ({
  type: VERIFY_OTP_SUCCESS,
  payload: result,
});
export const verifyOtpError = error => ({
  type: VERIFY_OTP_ERROR,
  payload: error,
  error: true,
});

export const insertFieldOptionsRequest = params => ({
  type: INSERT_FIELD_OPTIONS_REQUEST,
  payload: { params },
});
export const insertFieldOptionsSuccess = result => ({
  type: INSERT_FIELD_OPTIONS_SUCCESS,
  payload: result,
});
export const insertFieldOptionsError = error => ({
  type: INSERT_FIELD_OPTIONS_ERROR,
  payload: error,
  error: true,
});

export const sendMailRequest = params => ({
  type: SEND_MAIL_REQUEST,
  payload: { params },
});
export const sendMailSuccess = result => ({
  type: SEND_MAIL_SUCCESS,
  payload: result,
});
export const sendMailError = error => ({
  type: SEND_MAIL_ERROR,
  payload: error,
  error: true,
});

export const getAllCandidatesListingsRequest = params => ({
  type: GET_ALL_CANDIDATES_LISTINGS_REQUEST,
  payload: { params },
});
export const getAllCandidatesListingsSuccess = result => ({
  type: GET_ALL_CANDIDATES_LISTINGS_SUCCESS,
  payload: result,
});
export const getAllCandidatesListingsError = error => ({
  type: GET_ALL_CANDIDATES_LISTINGS_ERROR,
  payload: error,
  error: true,
});

export const sendConsultantMailRequest = params => ({
  type: SEND_CONSULTANT_MAIL_REQUEST,
  payload: { params },
});
export const sendConsultantMailSuccess = result => ({
  type: SEND_CONSULTANT_MAIL_SUCCESS,
  payload: result,
});
export const sendConsultantMailError = error => ({
  type: SEND_CONSULTANT_MAIL_ERROR,
  payload: error,
  error: true,
});

export const updateProfileListingRequest = params => ({
  type: UPDATE_PROFILE_LISTING_REQUEST,
  payload: { params },
});
export const updateProfileListingSuccess = result => ({
  type: UPDATE_PROFILE_LISTING_SUCCESS,
  payload: result,
});
export const updateProfileListingError = error => ({
  type: UPDATE_PROFILE_LISTING_ERROR,
  payload: error,
  error: true,
});

export const updateLinkedConsultantRequest = params => ({
  type: UPDATE_LINKED_CONSULTANT_REQUEST,
  payload: { params },
});
export const updateLinkedConsultantSuccess = result => ({
  type: UPDATE_LINKED_CONSULTANT_SUCCESS,
  payload: result,
});
export const updateLinkedConsultantError = error => ({
  type: UPDATE_LINKED_CONSULTANT_ERROR,
  payload: error,
  error: true,
});

export const shareProfileRequest = params => ({
  type: SHARE_PROFILE_REQUEST,
  payload: { params },
});
export const shareProfileSuccess = result => ({
  type: SHARE_PROFILE_SUCCESS,
  payload: result,
});
export const shareProfileError = error => ({
  type: SHARE_PROFILE_ERROR,
  payload: error,
  error: true,
});

export const getProfileAccessRequestsRequest = () => ({
  type: GET_PROFILE_ACCESS_REQUESTS_REQUEST,
});
export const getProfileAccessRequestsSuccess = result => ({
  type: GET_PROFILE_ACCESS_REQUESTS_SUCCESS,
  payload: result,
});
export const getProfileAccessRequestsError = error => ({
  type: GET_PROFILE_ACCESS_REQUESTS_ERROR,
  payload: error,
  error: true,
});

export const approveAccessRequestRequest = () => ({
  type: APPROVE_ACCESS_REQUEST_REQUEST,
});
export const approveAccessRequestSuccess = result => ({
  type: APPROVE_ACCESS_REQUEST_SUCCESS,
  payload: result,
});
export const approveAccessRequestError = error => ({
  type: APPROVE_ACCESS_REQUEST_ERROR,
  payload: error,
  error: true,
});

export const rejectAccessRequestRequest = () => ({
  type: REJECT_ACCESS_REQUEST_REQUEST,
});
export const rejectAccessRequestSuccess = result => ({
  type: REJECT_ACCESS_REQUEST_SUCCESS,
  payload: result,
});
export const rejectAccessRequestError = error => ({
  type: REJECT_ACCESS_REQUEST_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //

// Images return imageId which we need to map with previously generated temporary id
export function uploadImage(actionPayload) {
  return async (dispatch, getState, sdk) => {
    const id = actionPayload.id;
    dispatch(uploadImageRequest(actionPayload));

    const bodyParams = {
      image: actionPayload.file,
    };
    const queryParams = {
      expand: true,
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    const formData = new FormData();

    formData.append('file', actionPayload.file);
    let blobUrl = '';
    await uploadFileToBlob(formData)
      .then(res => {
        blobUrl = res?.blobUrl;
      }).catch(e => {
        dispatch(uploadImageError({ id, error: storableError(e) }));
      });

    const currentUser = getState().user.currentUser;
    const currentUserId = currentUser?.id?.uuid;

    return sdk.images
      .upload(bodyParams, queryParams)
      .then(resp => {
        const uploadedImage = resp.data.data;
        dispatch(uploadImageSuccess({ data: { id, uploadedImage } }));
        // Update the profile with the uploaded image

        return sdk.currentUser.updateProfile({
          profileImageId: new UUID(uploadedImage?.id?.uuid),
        })
          .then(async () => {
            await updateOtherUsers({ userId: currentUserId, updateCurrProfile: true, uploadedImageId: uploadedImage?.id?.uuid, blobUrl: blobUrl });

            const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId
              || currentUser?.attributes?.profile?.publicData?.firstListingId;
            if (profileListingId) {
              await sdk.ownListings.update(
                { id: new UUID(profileListingId), images: [uploadedImage.id] },
                { expand: true }
              ).catch(() => {});
            }

            dispatch(showProfileListing());
          })
          .catch(e => {
            // Profile update after image upload failed - error already stored
          });
      })
      .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
  };
}

export function uploadBlobFile(actionPayload) {
  return (dispatch, getState, sdk) => {
    const id = actionPayload.id;
    const formData = new FormData();

    formData.append('file', actionPayload.file);
    dispatch(uploadBlobFileRequest(actionPayload));

    return uploadFileToBlob(formData)
      .then(res => {
        const blobUrl = res?.blobUrl;
        dispatch(uploadBlobFileSuccess({ data: { id, blobUrl } }));
        return res;
      })
      .catch(e => {
        dispatch(uploadBlobFileError({ id, error: storableError(e) }));
      });
  };
}

// Upload resume to dedicated Resume container
export function uploadResumeBlobFile(actionPayload) {
  return (dispatch, getState, sdk) => {
    const id = actionPayload.id;
    const formData = new FormData();

    formData.append('file', actionPayload.file);
    const userId = actionPayload.userId || '';
    const candidateListingId = actionPayload.candidateListingId || '';
    formData.append('userId', userId);
    formData.append('candidateListingId', candidateListingId);

    dispatch(uploadBlobFileRequest(actionPayload));

    return uploadResumeToBlob(formData)
      .then(res => {
        const blobUrl = res?.blobUrl;
        dispatch(uploadBlobFileSuccess({ data: { id, blobUrl } }));
        return res;
      })
      .catch(e => {
        dispatch(uploadBlobFileError({ id, error: storableError(e) }));
      });
  };
}

export const updateProfile = actionPayload => {
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());

    const state = getState();
    const { agencyLinkTxnId } = state.ProfileSettingsPage;
    const { currentUser } = state.user;

    if (agencyLinkTxnId) {

      actionPayload.publicData.agencyLinkTxnIds = [
        ...(Array.isArray(actionPayload?.publicData?.agencyLinkTxnIds) ? actionPayload.publicData.agencyLinkTxnIds : Array.isArray(currentUser?.attributes?.profile?.publicData?.agencyLinkTxnIds) ? currentUser?.attributes?.profile?.publicData.agencyLinkTxnIds : []),
        agencyLinkTxnId
      ];

      actionPayload.publicData.agencyLinkTxnIds = actionPayload?.publicData?.agencyLinkTxnIds?.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t === value
        ))
      );

      actionPayload.publicData.currentAgencyLinkTxnId = agencyLinkTxnId;
    }

    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.currentUser
      .updateProfile(actionPayload, queryParams)
      .then(async response => {
        dispatch(updateProfileSuccess(response));

        await updateOtherUsers({ userId: currentUser?.id.uuid, response, updateOwnProfile: true })
          .catch(er => {
            dispatch(updateProfileError(storableError(er)));
          });

        dispatch(showProfileListing());

        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUserReturn = entities[0];

        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(currentUserReturn));
      })
      .catch(e => {
        // Error dispatched via updateProfileError, then passed on so the caller does not report a
        // save that never happened as a success.
        dispatch(updateProfileError(storableError(e)));
        throw e;
      });
  };
};

// How many of an organisation's links the settings view shows at once, in each list.
export const OWN_LINK_PAGE_SIZE = 6;

// The link lists the settings view shows: a candidate's linked partners, an agency's consultants,
// and a company's consultants and preferred vendors.
const ownLinkListsFor = userType =>
  userType === 'candidate'
    ? ['recruiters']
    : userType === 'agency'
    ? ['staffingConsultants', 'implementationConsultants']
    : ['staffingConsultants', 'implementationConsultants', 'staffingVendors', 'implementationVendors'];

const CONSULTANT_LISTS = ['staffingConsultants', 'implementationConsultants'];
const VENDOR_LISTS = ['staffingVendors', 'implementationVendors'];

// Reads `page` of each of `lists`, then the candidate and agency listings of the rows read, which
// the rows show their names and pictures from.
const fetchOwnLinkPages = (lists, page) => async (dispatch, getState) => {
  const ownerId = await dispatch(ensureProfileListingAdminId());
  await Promise.all(
    lists.map(list =>
      dispatch(fetchLinkPage({ scope: 'own', list, ownerId, page, perPage: OWN_LINK_PAGE_SIZE }))
    )
  );

  const own = getState().linkedContacts?.own || {};
  const listingIdsOn = names => [
    ...new Set(
      names
        .filter(name => lists.includes(name))
        .flatMap(name => own[name]?.items || [])
        .map(row => row.listingId)
        .filter(Boolean)
    ),
  ];
  const candidateIds = listingIdsOn(CONSULTANT_LISTS);
  const agencyIds = listingIdsOn(VENDOR_LISTS);
  if (candidateIds.length || agencyIds.length) {
    await dispatch(fetchAllCandidatesListings({ candidateIds, agencyIds }));
  }
};

/**
 * Reads one page of one of the organisation's link lists for the settings view, with the listings
 * its rows show.
 */
export const fetchOwnLinkPage = (list, page) => fetchOwnLinkPages([list], page);

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = (params, search, config) => async (dispatch, getState) => {
  let currentUser = getState()?.user?.currentUser;

  // Ensure onboarding decision reads a populated currentUser on first load.
  if (!currentUser) {
    await dispatch(fetchCurrentUser({
      enforce: true,
      updateHasListings: false,
      updateNotifications: false,
    }));
    currentUser = getState()?.user?.currentUser;
  }

  if (!currentUser) {
    return true;
  }

  const publicData = currentUser?.attributes?.profile?.publicData;
  const profileListingId = publicData?.profileListingId || publicData?.firstListingId;
  const hasProfileListing = profileListingId != undefined;
  const searchParams = new URLSearchParams(search || '');
  const applyWorkId = searchParams.get('applyWorkId');

  // Core calls that are always needed
  const calls = [
    dispatch(checkForOwnListings()),
    dispatch(fetchPhoneVerificationsDuck()),
  ];

  if (applyWorkId) {
    calls.push(dispatch(showApplyWorkListing(applyWorkId)));
  }

  // Only fetch listing-dependent data when the user has a profile listing
  if (hasProfileListing) {
    calls.push(dispatch(showProfileListing()));
    calls.push(dispatch(fetchUserPersonaRecords(profileListingId)));
    calls.push(dispatch(getUsersLinkedProjects()));
    calls.push(dispatch(fetchOwnLinkPages(ownLinkListsFor(userTypeOf(currentUser)), 1)));
  }

  await Promise.all(calls);

  return true;
};

// Onboarding finishes on ProfileSettingsPage itself, so the router never re-runs
// loadData (RouteComponentRenderer only calls it when pathname/search changes) and
// isFreshUser stays true — leaving the user staring at the onboarding form. Re-fetch
// the user first: createNewListing sets firstListingId server-side, so the Redux copy
// is stale and both checkForOwnListings and loadData would read the pre-onboarding
// profile. Then re-run loadData to flip isFreshUser and pull the listing-dependent data.
export const refreshAfterOnboarding = (search, config) => async dispatch => {
  await dispatch(
    fetchCurrentUser({
      enforce: true,
      updateHasListings: false,
      updateNotifications: false,
    })
  );
  return dispatch(loadData({}, search, config));
};

export const checkForOwnListings = (params, search, config) => (dispatch, getState, sdk) => {
  dispatch(checkForOwnListingsRequest());

  return sdk.ownListings
    .query()
    .then(async response => {
      let currentUser = getState().user.currentUser;
      if (!currentUser) {
        await dispatch(fetchCurrentUser({
          enforce: true,
          updateHasListings: false,
          updateNotifications: false,
        }));
        currentUser = getState().user.currentUser;
      }

      if (!currentUser) {
        dispatch(checkForOwnListingsSuccess(null));
        return response;
      }

      // const isEmptyResponse = response?.data?.data?.length === 0;
      // const isNotCandidate = publicData?.userType !== 'candidate';
      // const isNotAdmin = publicData?.role !== undefined && publicData?.role !== 'Admin';
      // const hasNotJoined = publicData?.addedUserJoined !== true;

      // if ((isNotCandidate && isNotAdmin && hasNotJoined) || (isEmptyResponse && (!isNotCandidate || !isNotAdmin))) {
      //   isFreshUser = true;
      // }

      dispatch(checkForOwnListingsSuccess(isFreshUserOf(currentUser)));
      return response;
    }).catch((error) => {
      // The answer comes from the user's profile, so a failed listings query can still give it.
      const currentUser = getState().user.currentUser;
      dispatch(checkForOwnListingsError(storableError(error), currentUser ? isFreshUserOf(currentUser) : undefined));
      throw error;
    });
};

export const showProfileListing = () => async (dispatch, getState, sdk) => {
  dispatch(showProfileListingRequest());

  const state = getState();
  const { currentUser } = state.user;

  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId || currentUser?.attributes?.profile?.publicData?.firstListingId;

  if (profileListingId === undefined) {
    return null;
  }

  return sdk.listings
    .show({ id: profileListingId, include: ['author'] })
    .then(async response => {
      dispatch(profileListingAuthorResolved(response.data.data.relationships?.author?.data?.id?.uuid || null));
      // The person's wallet records are in the listing's private data, which the public read does
      // not return.
      const ownListing = await withOwnPrivateData(response.data.data, profileListingId);
      const loaded = await loadCompanyCredentialDetails(ownListing, profileListingId);
      dispatch(showProfileListingSuccess(loaded.listing, { credentialsLoaded: loaded.credentialsLoaded }));
      return true;
    })
    .catch(e => {
      dispatch(showProfileListingError(storableError(e)));
      return false;
    });;
};

// The user and company listing as stored right now, read for a section save so that fields the
// person did not change are saved as they are now rather than as the page loaded them. Nothing is
// put in the store: the page's own refreshes do that. A failed user read rejects (the save cannot
// know what is stored); a company listing that exists but cannot be read is reported as such.
export const loadLatestProfileForSave = () => async (dispatch, getState, sdk) => {
  const userResponse = await sdk.currentUser.show({ include: ['profileImage'] });
  const [currentUser] = denormalisedResponseEntities(userResponse);
  const publicData = currentUser?.attributes?.profile?.publicData || {};
  const profileListingId = publicData.profileListingId || publicData.firstListingId;
  if (!profileListingId) {
    return { currentUser, profileListing: null, profileListingUnreadable: false };
  }
  try {
    const listingResponse = await sdk.listings.show({ id: profileListingId });
    const ownListing = await withOwnPrivateData(listingResponse.data.data, profileListingId);
    const loaded = await loadCompanyCredentialDetails(ownListing, profileListingId);
    return { currentUser, profileListing: loaded.listing, profileListingUnreadable: false };
  } catch (e) {
    return { currentUser, profileListing: null, profileListingUnreadable: true };
  }
};

export const showApplyWorkListing = listingId => async (dispatch, getState) => {
  if (!listingId) {
    return null;
  }

  dispatch(showApplyWorkListingRequest({ listingId }));

  return getListingWithPrivateData({ listingId, listingPage: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));

      const listingRef = response?.data?.data?.id || new UUID(listingId);
      const listing = getMarketplaceEntities(getState(), [{ id: listingRef, type: 'listing' }])[0] || null;
      dispatch(showApplyWorkListingSuccess({ listingId: listingRef, listing }));
      return true;
    })
    .catch(e => {
      dispatch(showApplyWorkListingError(storableError(e)));
      return false;
    });
};

// The metadata of an agency's company listing, where the projects candidates recorded against it
// are held. A listing that cannot be read offers the agency's own projects only.
const companyListingMetadataOf = (sdk, listingId) =>
  listingId
    ? sdk.listings
        .show({ id: listingId })
        .then(res => res?.data?.data?.attributes?.metadata || {})
        .catch(() => ({}))
    : Promise.resolve({});

export const initiateAgencyLink = (agencyUserId) => async (dispatch, getState, sdk) => {
  dispatch(initiateAgencyLinkRequest());

  return sdk.users.show({ id: agencyUserId }).then(res => {

    const profileListingId =
      res.data.data?.attributes?.profile?.publicData?.profileListingId ||
      res.data.data?.attributes?.profile?.publicData?.firstListingId;

    const ownProjects = res.data.data?.attributes?.profile?.publicData?.projectsExecuted;

    return companyListingMetadataOf(sdk, profileListingId).then(metadata =>
      sdk.transactions
        .initiate(
          {
            processAlias: 'default-agency-link/release-1',
            transition: 'transition/agency-link',
            params: {
              listingId: profileListingId,
            },
          },
          {
            expand: true,
          }
        )
        .then(response => {
          const agencyLinkTxnId = response?.data?.data?.id?.uuid;
          const projectOptions = agencyProjectOptions(ownProjects, metadata).map(p => ({
            ...p,
            transactionId: agencyLinkTxnId,
          }));

          dispatch(initiateAgencyLinkSuccess({ agencyLinkTxnId, projectOptions }));
          return true;
        })
        .catch(e => dispatch(initiateAgencyLinkError(storableError(e))))
    );
  });
};

export const updateOtherUser = (actionPayload) => async (dispatch, getState, sdk) => {
  dispatch(updateOtherUserRequest());

  if (actionPayload?.onBoardingOpenToWork === true || actionPayload?.onBoardingOpenToWork === false) {
    const currentUser = getState().user.currentUser;

    return updateOtherUsers({ ...actionPayload, userId: currentUser?.id, email: currentUser?.attributes?.email, firstName: currentUser?.attributes?.profile?.firstName })
      .then(res => {
        dispatch(updateOtherUserSuccess(res));
      })
      .catch(e => dispatch(updateOtherUserError(e)));
  }

  return updateOtherUsers(actionPayload)
    .then(res => {
      dispatch(updateOtherUserSuccess(res));
    })
    .catch(e => dispatch(updateOtherUserError(e)));
};

export const updateTransactionMetadataDuck = (actionPayload) => async (dispatch, getState, sdk) => {
  dispatch(updateTransactionMetadataRequest());

  return updateTransactionMetadata(actionPayload)
    .then(res => {
      dispatch(updateTransactionMetadataSuccess(res));
      dispatch(getUsersLinkedProjects());
    })
    .catch(e => dispatch(updateOtherUserError(e)));
};

export const getUsersLinkedProjects = () => async (dispatch, getState, sdk) => {
  dispatch(getUsersLinkedProjectsRequest());

  try {

    const state = getState();
    const { currentUser } = state.user;

    const isCandidate = userTypeOf(currentUser) === 'candidate';

    if (!isCandidate)
      return;

    const hasAgencyLinkTransactions = currentUser?.attributes?.profile?.publicData?.agencyLinkTxnIds !== undefined && currentUser?.attributes?.profile?.publicData?.agencyLinkTxnIds?.length > 0;

    if (!hasAgencyLinkTransactions)
      return;

    const agencyLinkTxnIds = currentUser?.attributes?.profile?.publicData?.agencyLinkTxnIds;

    let profileLinkedProjects = [];
    let offeredProjects = [];

    await Promise.all(
      agencyLinkTxnIds?.map(async txnId => {
        const txn = await sdk.transactions.show({
          id: new UUID(txnId),
          include: ['provider'],
        });

        const projectIds = txn?.data?.data?.attributes?.metadata?.projectIds || [];
        const provider =
          (txn?.data?.included || []).find(item => item?.type === 'user') || txn?.data?.included?.[0];
        const providerPublicData = provider?.attributes?.profile?.publicData || {};
        const metadata = await companyListingMetadataOf(
          sdk,
          providerPublicData.profileListingId || providerPublicData.firstListingId
        );
        const agencyProjects = agencyProjectOptions(providerPublicData.projectsExecuted, metadata).map(
          project => ({ ...project, transactionId: txnId })
        );

        offeredProjects = [...offeredProjects, ...agencyProjects];

        agencyProjects.forEach(project => {
          if (projectIds.includes(project.id)) {
            profileLinkedProjects.push(project);
          }
        });
      })
    );

    const unique = list =>
      list.filter((value, index, self) =>
        index === self.findIndex(t => JSON.stringify(t) === JSON.stringify(value))
      );

    profileLinkedProjects = unique(profileLinkedProjects);

    const projectOptions = unique(offeredProjects).filter(project => {
      return !profileLinkedProjects.some(linkedProject => linkedProject.id === project.id);
    });

    const payload = { profileLinkedProjects, agencyProjectOptions: projectOptions };
    dispatch(getUsersLinkedProjectsSuccess(payload));
    return true;
  }
  catch (error) {
    // Error dispatched via getUsersLinkedProjectsError
    dispatch(getUsersLinkedProjectsError(error));
  }
};

export const showUpdatedUser = (actionPayload) => async (dispatch, getState, sdk) => {
  dispatch(showUpdatedUserRequest());

  return sdk.users.show({ id: new UUID(actionPayload) }).then(res => {

    dispatch(showProfileListingSuccess(res.data.data));
    return res.data.data;
  }).catch(err => dispatch(showUpdatedUserError(err)));

};

export const fetchLocationDetails = (params) => async (dispatch, getState, sdk) => {
  dispatch(fetchLocationDetailsRequest());

  return getLocationDetails(params)
    .then(res => {
      dispatch(fetchLocationDetailsSuccess());
      return res;
    })
    .catch(e => dispatch(fetchLocationDetailsError(e)));
};

export const sendOtpDuck = (params) => async (dispatch, getState, sdk) => {
  dispatch(sendOtpRequest(params));

  return sendOtp(params)
    .then(res => {
      dispatch(sendOtpSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(sendOtpError(storableError(e)));
      throw e;
    });
};

export const verifyOtpDuck = (params) => async (dispatch, getState, sdk) => {
  dispatch(verifyOtpRequest(params));

  return verifyOtp(params)
    .then(res => {
      dispatch(verifyOtpSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(verifyOtpError(storableError(e)));
      throw e;
    });
};

// Loads the phones the server has verified for the signed-in user. A failed load leaves every phone
// unverified; it never fails the page load it runs in.
export const fetchPhoneVerificationsDuck = () => dispatch => {
  dispatch({ type: FETCH_PHONE_VERIFICATIONS_REQUEST });
  return getPhoneVerifications()
    .then(res => {
      const phones = (res?.verifiedPhones || []).map(row => row?.phoneNumber).filter(Boolean);
      dispatch({ type: FETCH_PHONE_VERIFICATIONS_SUCCESS, payload: phones });
      return phones;
    })
    .catch(e => {
      dispatch({ type: FETCH_PHONE_VERIFICATIONS_ERROR, payload: storableError(e), error: true });
      return null;
    });
};

export const insertFieldOptions = (params) => async (dispatch, getState, sdk) => {
  dispatch(insertFieldOptionsRequest());

  try {
    await manualFieldOptions(params);

    await dispatch(loadFieldOptions());

    dispatch(insertFieldOptionsSuccess());
    return true;

  } catch (e) {
    dispatch(insertFieldOptionsError(e));
    throw e;
  }
};

// Ask the candidate's current employer to confirm them. Resolves `{ sent, message? }` and never
// rejects: a profile save goes on whatever happens here, and `message` is the server's own
// explanation when it gave one (a request limit reached, or an address it will not mail).
const askCurrentEmployer = async (currentEmployer, currentUser, dispatch) => {
  const receiverMail = currentEmployer?.current_company_poc_email;
  const receiverName = currentEmployer?.current_company?.label;
  const senderName =
    currentUser?.attributes?.profile?.displayName || currentUser?.attributes?.profile?.firstName || 'Anonymous';

  // The chosen company lets the server tell a company on the platform from a typed name.
  const chosen = currentEmployer?.current_company || {};
  const currentCompany = { label: chosen.label, ...(chosen.listingId ? { listingId: chosen.listingId } : {}) };

  try {
    const res = await sendConsCurrEmpMail({ senderName, receiverMail, receiverName, currentCompany, mailCurrEmp: true });
    dispatch(sendMailSuccess(res));
    if (res?.emailSent === false) {
      return typeof res.message === 'string' && res.message ? { sent: false, message: res.message } : { sent: false };
    }
    return { sent: true };
  } catch (err) {
    dispatch(sendMailError(storableError(err)));
    const refusedWithReason = err?.status === 409 && typeof err?.message === 'string' && err.message;
    return refusedWithReason ? { sent: false, message: err.message } : { sent: false };
  }
};

export const sendMail = (actionPayload) => async (dispatch, getState, sdk) => {
  dispatch(sendMailRequest());

  if (actionPayload?.mailCurrEmp) {
    return askCurrentEmployer(actionPayload?.currentEmployer, getState()?.user?.currentUser, dispatch);
  }

  try {
    const state = getState();
    const { currentUser } = state.user;

    const profileListingId =
      currentUser?.attributes?.profile?.publicData?.profileListingId ||
      currentUser?.attributes?.profile?.publicData?.firstListingId;

    const profileListingRes = await sdk.listings.show({ id: profileListingId });
    const profileListing = profileListingRes?.data?.data;

    let senderName =
      profileListing?.attributes?.publicData?.agencyProfile?.name ||
      profileListing?.attributes?.publicData?.customerProfile?.name ||
      "Anonymous";

    if (actionPayload?.mailCons && Array.isArray(actionPayload.consultants)) {

      const results = await Promise.allSettled(
        actionPayload.consultants.map(async (c) => {
          try {
            if (c?.mailSent) {
              // console.log("Skipping consultant (already sent):", c.id);
              return null;
            }
            if (!c?.email) {
              // console.log("Skipping consultant (missing email):", c.id);
              return null;
            }

            // console.log("Fetching listing for:", c.listingId);

            const receiverMail = c?.email;
            const receiverName = c?.label;

            if (!receiverMail) {
              return { consultantId: c?.id, success: false };
            }

            const toSendActionPayload = {
              senderName,
              receiverMail,
              receiverName,
              mailCons: true,
            };

            // console.log("Sending mail:", toSendActionPayload);

            // make sure this returns a promise
            await sendConsCurrEmpMail(toSendActionPayload);

            return { consultantId: c.id, success: true };
          } catch (err) {
            // Error in consultant mail - rethrown for Promise.allSettled
            throw err;
          }
        })
      );
    }

  } catch (error) {
    // Error dispatched via sendMailError
    dispatch(sendMailError(false));
  }
};

export const fetchAllCandidatesListings = ({ candidateIds = [], agencyIds = [] } = {}) => async (dispatch, getState, sdk) => {
  dispatch(getAllCandidatesListingsRequest());

  try {
    let response = { candidateListings: [], agencyListings: [] };

    // Fetch only the needed candidate listings
    if (candidateIds.length > 0) {
      const candidateRes = await getListingsByIds({ ids: candidateIds, listingType: 'candidate' });
      response.candidateListings = candidateRes.data.data;
    }

    // Fetch only the needed agency listings
    if (agencyIds.length > 0) {
      const agencyRes = await getListingsByIds({ ids: agencyIds, listingType: 'agency' });
      response.agencyListings = agencyRes.data.data;
    }

    dispatch(getAllCandidatesListingsSuccess(response));
  } catch (e) {
    dispatch(getAllCandidatesListingsError(storableError(e)));
    throw e;
  }
};

export const sendConsultantMail = (params) => async (dispatch, getState, sdk) => {
  dispatch(sendConsultantMailRequest());

  const consultants = params?.consultants?.filter(x => !x.emailSent);
  if (consultants?.length) {
    const { currentUser } = getState().user;

    const currentUserName = currentUser.attributes.profile.displayName;
    const currentUserId = currentUser.id.uuid;
    const agencyProfileName = currentUser?.attributes?.profile?.publicData?.agencyProfile?.name;
    const agencyName = agencyProfileName || currentUser?.attributes?.profile?.publicData?.customerProfile?.name;
    // Agencies invite "staffing consultants"; customers invite "preferred consultants".
    const isAgency = !!agencyProfileName;

    return sendConsultantInvite({ consultants, currentUserName, currentUserId, agencyName, isAgency })
      .then(res => {
        dispatch(sendConsultantMailSuccess(res));
        return res;
      })
      .catch(e => {
        dispatch(sendConsultantMailError(storableError(e)));
        throw e;
      });
  }

  return false;
};

export const updateProfileListing = (actionPayload) => async (dispatch, getState, sdk) => {
  dispatch(updateProfileListingRequest());

  // return sdk.listings.update(actionPayload)
  return createNewListing({
    listingId: actionPayload?.listingId,
    documentVerificationChecks: actionPayload?.documentVerificationChecks,
    personaDocumentDetails: actionPayload?.personaDocumentDetails,
    verificationIdentityChecks: actionPayload?.verificationIdentityChecks,
    documentInquiryIds: actionPayload?.documentInquiryIds,
    documentCompletionHistory: actionPayload?.documentCompletionHistory,
    dockIoCredentials: actionPayload?.dockIoCredentials,
    selectedWalletDocs: actionPayload?.selectedWalletDocs,
    saveDock: true
  })
    .then(res => {
      dispatch(updateProfileListingSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(updateProfileListingError(storableError(e)));
      throw e;
    });
};

export const updateLinkedConsultantDuck = (params) => async (dispatch, getState, sdk) => {
  dispatch(updateLinkedConsultantRequest());

  let payload = {};
  if (params?.deleteRecord || params?.acceptRecord || params?.declineRecord || params?.requestAgainRecord) {
    payload = {
      ...params,
    };
  } else {
    // Links are added and removed one at a time; a whole consultant list is no longer saved.
    const refusal = { success: false, error: 'LINK_LIST_SAVE_NOT_SUPPORTED' };
    dispatch(updateLinkedConsultantError(refusal));
    return refusal;
  }

  return updateLinkedConsultant(payload)
    .then(res => {
      dispatch(updateLinkedConsultantSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(updateLinkedConsultantError(storableError(e)));
      return false;
      // throw e;
    });
};

export const shareProfileDuck = (params) => async (dispatch, getState, sdk) => {
  dispatch(shareProfileRequest());

  const { email, profileListingId, profileListingSlug, displayName, recipientFirstName, recipientLastName, recipientCompanyName, message } = params;

  return shareProfile({ email, profileListingId, profileListingSlug, displayName, recipientFirstName, recipientLastName, recipientCompanyName, message })
    .then(res => {
      dispatch(shareProfileSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(shareProfileError(storableError(e)));
      throw e;
    });
};

export const getProfileAccessRequestsDuck = (profileOwnerId) => async (dispatch, getState, sdk) => {
  dispatch(getProfileAccessRequestsRequest());

  return getProfileAccessRequests({ profileOwnerId })
    .then(res => {
      dispatch(getProfileAccessRequestsSuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(getProfileAccessRequestsError(storableError(e)));
      throw e;
    });
};

export const approveAccessRequestDuck = (params) => async (dispatch, getState, sdk) => {
  dispatch(approveAccessRequestRequest());

  const { requestId, profileListingSlug, displayName } = params;

  return approveAccessRequest({ requestId, profileListingSlug, displayName })
    .then(res => {
      dispatch(approveAccessRequestSuccess({ ...res, requestId }));
      // Refetch profile access requests to update the list
      dispatch(fetchCurrentUserProfileAccessRequests());
      return res;
    })
    .catch(e => {
      dispatch(approveAccessRequestError(storableError(e)));
      throw e;
    });
};

export const rejectAccessRequestDuck = (params) => async (dispatch, getState, sdk) => {
  dispatch(rejectAccessRequestRequest());

  const { requestId, profileOwnerName, profileTitle } = params;

  return rejectAccessRequest({ requestId, profileOwnerName, profileTitle })
    .then(res => {
      dispatch(rejectAccessRequestSuccess({ ...res, requestId }));
      // Refetch profile access requests to update the list
      dispatch(fetchCurrentUserProfileAccessRequests());
      return res;
    })
    .catch(e => {
      dispatch(rejectAccessRequestError(storableError(e)));
      throw e;
    });
};

// Search users on-demand for SearchableSelectInput fields.
// Returns results directly to the caller (no Redux state needed).
export const searchUsersForSelect = (params) => async (dispatch) => {
  const response = await searchUsers(params);
  return response?.data || [];
};

// Save document upload consent (IdWorkAuthDocUpload)
export const saveDocConsentAction = (consentData) => (dispatch) => {
  dispatch({ type: SAVE_DOC_CONSENT_REQUEST });

  return saveConsent(consentData)
    .then(response => {
      dispatch({ type: SAVE_DOC_CONSENT_SUCCESS });
      return response;
    })
    .catch(e => {
      dispatch({ type: SAVE_DOC_CONSENT_ERROR, payload: storableError(e) });
      throw e;
    });
};
